<script setup>
import { computed, nextTick } from 'vue';
import vClickOutside from '/app/directives/click-outside';
import { useEscapeStack } from '/app/composables/escape-stack';

const props = defineProps({
    modelValue: Boolean,
    disabled: Boolean,
    width: [Number, String],
    boxClass: {
        type: [String, Array, Object],
        default: 'border-dust'
    }
});

const emit = defineEmits(['update:modelValue', 'change', 'close', 'open']);

const active = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
});

const style = computed(() => ({
    width: props.width && `${props.width}px`
}));

function toggle() {
    if (props.disabled) {
        return;
    }

    active.value = !active.value;
    emit('change', active.value);

    nextTick(() => {
        if (active.value) {
            emit('open');
        } else {
            emit('close');
        }
    });
}

function close() {
    active.value = false;
    emit('close');
}

useEscapeStack(active, () => close());
</script>

<template>
    <div class="relative h-[35px] sm:h-auto" :style="style">
        <div
            v-click-outside="close"
            class="absolute z-[11] w-full rounded-lg border bg-white px-[15px] py-[5px]"
            :class="[boxClass, { 'z-[20] shadow-active': active }]"
        >
            <slot name="activator" :close="close" :on="{ click: toggle, 'click.outside': toggle }" />
            <div v-show="active">
                <slot />
            </div>
        </div>
    </div>
</template>
